import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LogoutEffect } from "../redux/auth/AuthEffect";
import { logout } from "../redux/auth/AuthAction";
import LogoutDialogbox from "./notification/LogoutDialogbox";
import { APP_LINK } from "./global/MenuItems";
import { firebaseConfig } from "./loginWithGoogle/fireBaseConfig"
import { getAuth, signOut } from "firebase/auth";
import { initializeApp } from "firebase/app";

const Logout = () => {
  const [showDialog, setShowDialog] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);

  const handleLogout = async () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.clear();
    sessionStorage.clear();
    try {
      await signOut(auth);
      await LogoutEffect.post("/logout");
    } catch (error) {
    }
    dispatch(logout());
    navigate(APP_LINK.LOGIN);
  };

  const openDialog = () => setShowDialog(true);
  const closeDialog = () => setShowDialog(false);

  return (
    <div className="logout">
      <LogoutDialogbox
        open={openDialog}
        onConfirm={handleLogout}
        onCancel={closeDialog}
      />
    </div>
  );
};

export default Logout;
